module.exports = __webpack_public_path__ + "static/media/udeJouge.de2c5328.png";